
import { Component } from 'vue-facing-decorator'
import { ListViewVue } from '@/common/BaseVue'

@Component({})
export default class extends ListViewVue {
  listType = "router";

  getList() {
    return this.$post("/manager/postage/postage-list", this.mesureData);
  }

  async delRow(id) {
    await this.$postError("/manager/postage/postage-delete", {
      id,
    });
    this.$success("删除成功");
    this.refresh();
  }

  async setDefault(row) {
    await this.$confirm("是否设置为默认运费模板？");
    await this.$postError("/manager/postage/postage-set-default", {
      id: row.id,
      isDefault: row.isDefault ? false : true
    });
    this.refresh();
  }

  operat(id?) {
    if (id) {
      return this.$goto({
        name: "postage-operat",
        query: {
          id,
        },
      });
    }
    this.$goto({
      name: "postage-operat",
    });
  }
}
